export default {

    // Overall app related state…
    booting: true, // Is the app currently booting up?

    // - - - - - - - - - - - - - - - -

    // Pane related state…
    currentPaneId: null,
    prevPaneId: null, // Deprecated in favour of the last `openedPaneIds`.
    openedPaneIds: [],

    // - - - - - - - - - - - - - - - -

    // Pane options related state…
    paneOptionsComponents: {}, // Value might look like `{ 'PANE_OPTIONS_1_ID' : { 'open': true }, 'PANE_OPTIONS_2_ID' : { 'open': false } }`.

    // - - - - - - - - - - - - - - - -

    // Pane option related state…
    currentPrimaryPaneOptionComponentId: null,

    // - - - - - - - - - - - - - - - -

    // Map filter related state…
    currentMapFilterCode: null,
    openedMapFilterCodes: [],
};


